import { Component, OnDestroy, OnInit } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";
import { Subscription } from "rxjs";

@Component({
    selector: "formly-repeat-section",
    templateUrl: `./repeat-section.html`
})
export class RepeatTypeComponent extends FieldArrayType implements OnInit, OnDestroy {
    hideExpression
    hideAddBtn
    hideRemoveBtn
    autoRepeatSub: Subscription;

    ngOnInit(): void {
        const fieldOptions = this.field?.fieldArray?.templateOptions;

        let property = fieldOptions?.hideButtonsProperty;
        let hideButtons = fieldOptions?.hideButtons;

        this.hideAddBtn = fieldOptions?.hideAddButton === undefined ||
            fieldOptions?.hideAddButton === null ?
            true :
            !fieldOptions?.hideAddButton;

        this.hideRemoveBtn = fieldOptions?.hideRemoveButton === undefined ||
            fieldOptions?.hideRemoveButton === null ?
            true :
            !fieldOptions?.hideRemoveButton;

        this.hideExpression = hideButtons;
        if (property) {
            this.hideExpression = this.formState.model[property] || hideButtons;
        }
        if(fieldOptions.autoRepeat) {
            this.autoRepeatSub = this.formControl.valueChanges.subscribe((controls) => {
                if (Object.keys(controls[0]).some(field => !!this.formControl.controls[this.formControl.length - 1].value[field])) {
                    this.add();
                }
            });
        }
    }


    public leave(event) {
        event.preventDefault();
    }

    public getFieldGroupLength() {
        return this.field.fieldGroup.length;
    }

    get fieldGroupChunks() {
        const opts = this.field?.fieldArray?.templateOptions || {};
        const groupRows = opts.groupRows;
        if (!groupRows) {
            // No grouping: each field in its own row
            return this.field.fieldGroup?.map(f => [f]) || [];
        }
        const itemsPerRow = opts.itemsPerRow || 3; // Accept itemsPerRow from templateOptions, default to 3
        const chunks = [];
        const group = this.field.fieldGroup || [];
        for (let i = 0; i < group.length; i += itemsPerRow) {
            chunks.push(group.slice(i, i + itemsPerRow));
        }
        return chunks;
    }

    get groupedFieldRows() {
        const opts = this.field?.fieldArray?.templateOptions || {};
        const groupRows = opts.groupRows;
        if (!groupRows) {
            // No grouping: each field in its own row
            return this.field.fieldGroup?.map(f => [f]) || [];
        }
        const itemsPerRow = opts.itemsPerRow || 3; // Accept itemsPerRow from templateOptions, default to 3
        const chunks = [];
        const group = this.field.fieldGroup || [];
        for (let i = 0; i < group.length; i += itemsPerRow) {
            chunks.push(group.slice(i, i + itemsPerRow));
        }
        return chunks;
    }

    ngOnDestroy(): void {
        if (this.autoRepeatSub) {
            this.autoRepeatSub.unsubscribe;
        }
    }

}

